import * as React from "react";

import { cn } from "../lib/utils";

/**
 * Tiny inline-SVG drop-in replacements for the lucide-react icons
 * used by the form-fill renderers. Bundled here so the package
 * doesn't peer-pin a lucide-react version against whichever release
 * the host happens to be on (apps/web's pinned lucide-react predates
 * the LucideProps narrowing that breaks `React.ComponentProps<'svg'>`
 * spreads).
 *
 * Each component accepts `className`; size defaults match the original
 * lucide defaults (`h-4 w-4` via the `size-4` shorthand).
 */
function makeIcon(d: React.ReactNode, fill: "none" | "currentColor" = "none") {
  return function Icon({
    className,
    ...props
  }: React.SVGProps<SVGSVGElement>) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill={fill}
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={cn("size-4", className)}
        aria-hidden
        {...props}
      >
        {d}
      </svg>
    );
  };
}

export const Check = makeIcon(<polyline points="20 6 9 17 4 12" />);
export const X = makeIcon(
  <>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </>,
);
export const ChevronDown = makeIcon(<polyline points="6 9 12 15 18 9" />);
export const ChevronUp = makeIcon(<polyline points="18 15 12 9 6 15" />);
export const ChevronLeft = makeIcon(<polyline points="15 18 9 12 15 6" />);
export const ChevronRight = makeIcon(<polyline points="9 18 15 12 9 6" />);
export const ChevronsUpDown = makeIcon(
  <>
    <path d="m7 15 5 5 5-5" />
    <path d="m7 9 5-5 5 5" />
  </>,
);
export const Circle = makeIcon(<circle cx="12" cy="12" r="10" />, "currentColor");
